// extracted by mini-css-extract-plugin
export default {"appleform":"SuspendedLanding_appleform__ntIUN","confirmBold":"SuspendedLanding_confirmBold__ysK8F"};